<h4 class="fw-bold">
    {{ "breadcrumbs.entities" | translate }}
    <span class="fw-light mx-1">
        @if (displayLabel) {
            - {{ displayLabel }}
        }
    </span>
</h4>

<form [formGroup]="entitiesForm">
    <div class="bg-card shadow p-2 rounded mb-2">
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.nameAE' | translate"
                    formControlName="nameAE"
                    controlName="nameAE"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('nameAE')"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.nameEN' | translate"
                    formControlName="nameEN"
                    controlName="nameEN"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('nameEN')"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.descriptionAE' | translate"
                    formControlName="dscAE"
                    controlName="dscAE"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('dscAE')"
                    [isTextArea]="true"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.descriptionEN' | translate"
                    formControlName="dscEN"
                    controlName="dscEN"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('dscEN')"
                    [isTextArea]="true"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    formControlName="shortNameAE"
                    controlName="shortNameAE"
                    [maxLength]="5"
                    [label]="'entity.create.shortName' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('shortNameAE')"
                    adaaSmartToolTips="shortName"
                />
            </div>
            <div class="col-md-3 col-sm-12 col-xs-12">
                <adaa-form-dropdown
                    formControlName="entityType"
                    controlName="entityType"
                    [label]="'entity.create.entity_type' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('entityType')"
                    [options]="entityTypeOptions()"
                    adaaSmartToolTips="entityType"
                />
            </div>
            <div class="col-md-3 col-sm-12 col-xs-12">
                <adaa-form-dropdown
                    formControlName="entitySize"
                    controlName="entitySize"
                    [label]="'entity.create.entity_size' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('entitySize')"
                    [options]="entitySizes()"
                    adaaSmartToolTips="availableEntities"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-dropdown
                    formControlName="yearOfEstablishment"
                    controlName="yearOfEstablishment"
                    [label]="'entity.create.established_date' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('yearOfEstablishment')"
                    [options]="establishedYears()"
                    [clearable]="true"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12 d-flex justify-content-center align-items-center">
                <adaa-form-checkbox
                    [label]="'entity.create.enabler' | translate"
                    [checkboxMode]="'yesNo'"
                    controlName="enabler"
                    formControlName="enabler"
                    adaaSmartToolTips="enablingEntity"
                />
            </div>
        </div>
    </div>

    @if (!isCreateMode()) {
        <div class="bg-card shadow p-2 rounded mb-2">
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-dropdown-multi
                        formControlName="ministers"
                        controlName="ministers"
                        [label]="'entity.minister' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('ministers')"
                        [options]="users()"
                        [clearable]="true"
                    />
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-dropdown-multi
                        formControlName="directorGenerals"
                        controlName="directorGenerals"
                        [label]="'entity.director_generals' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('directorGenerals')"
                        [options]="users()"
                        [clearable]="true"
                    />
                </div>
            </div>
        </div>
    }

    @if (isEditMode()) {
        <div class="bg-card shadow p-2 rounded mb-2">
            <div class="row">
                <div class="col-md-4 col-sm-12 col-xs-12">
                    <adaa-form-dropdown
                        formControlName="strategyManagerId"
                        controlName="strategyManagerId"
                        [label]="'entity.strategic_manager' | translate"
                        [setValidator]="formValidation()!"
                        [options]="users()"
                        [clearable]="true"
                    />
                </div>
                <div class="col-md-4 col-sm-12 col-xs-12">
                    <adaa-form-dropdown
                        formControlName="nkpiFocalPointId"
                        controlName="nkpiFocalPointId"
                        [label]="'entity.nkpi_focal_point' | translate"
                        [setValidator]="formValidation()!"
                        [options]="users()"
                        [clearable]="true"
                    />
                </div>
                <div class="col-md-4 col-sm-12 col-xs-12">
                    <adaa-form-dropdown
                        formControlName="ekpiFocalPointId"
                        controlName="ekpiFocalPointId"
                        [label]="'entity.ekpi_focal_point' | translate"
                        [setValidator]="formValidation()!"
                        [options]="users()"
                        [clearable]="true"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-12 col-xs-12">
                    <adaa-form-dropdown
                        formControlName="servicesFocalPointId"
                        controlName="servicesFocalPointId"
                        [label]="'entity.services_focal_point' | translate"
                        [setValidator]="formValidation()!"
                        [options]="users()"
                        [clearable]="true"
                    />
                </div>
                <div class="col-md-4 col-sm-12 col-xs-12">
                    <adaa-form-dropdown
                        formControlName="dkpiFocalPointId"
                        controlName="dkpiFocalPointId"
                        [label]="'entity.dkpi_focal_point' | translate"
                        [setValidator]="formValidation()!"
                        [options]="users()"
                        [clearable]="true"
                    />
                </div>
                <div class="col-md-4 col-sm-12 col-xs-12">
                    <adaa-form-dropdown
                        formControlName="skpiopmFocalPointId"
                        controlName="skpiopmFocalPointId"
                        [label]="'entity.skpiopm_focal_point' | translate"
                        [setValidator]="formValidation()!"
                        [options]="users()"
                        [clearable]="true"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-12 col-xs-12">
                    <adaa-form-dropdown
                        formControlName="aiFocalPointId"
                        controlName="aiFocalPointId"
                        [label]="'entity.aikpi_focal_point' | translate"
                        [setValidator]="formValidation()!"
                        [options]="users()"
                        [clearable]="true"
                    />
                </div>
            </div>
        </div>
    }

    <div class="bg-card shadow p-2 rounded mb-2">
        <div class="row my-4">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <p class="guidelines text-center fw-bold">{{ "entity.create.logo_horizontal" | translate }}</p>
                <adaa-form-input-file
                    [onDeleteRemoveFile]="false"
                    [isDisabled]="isViewMode()"
                    [onDeleteRemoveFile]="false"
                    [allowedFileSize]="100024"
                    [allowedFiles]="allowedFiles"
                    [allowedFilesMessage]="getFileMessage('logoHorizontalAttach')"
                    [file]="getImage('logoHorizontalAttach')"
                    (inputChanges)="onFilechange($event, 'logoHorizontalAttach')"
                    adaaSmartToolTips="horizontalLogo"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <p class="guidelines text-center fw-bold">{{ "entity.create.logo_vertical" | translate }}</p>
                <adaa-form-input-file
                    [onDeleteRemoveFile]="false"
                    [isDisabled]="isViewMode()"
                    [allowedFileSize]="100024"
                    [allowedFiles]="allowedFiles"
                    [allowedFilesMessage]="getFileMessage('logoVerticalAttach')"
                    [file]="getImage('logoVerticalAttach')"
                    (inputChanges)="onFilechange($event, 'logoVerticalAttach')"
                    adaaSmartToolTips="verticalLogo"
                />
            </div>
        </div>
    </div>
</form>

<div class="bg-card shadow p-2 rounded mb-2">
    <adaa-data-table
        #adaaDataTable
        [isLocalData]="true"
        [localData]="filteredOffices()"
        titleHeader="entity.create.entity_offices"
        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.ENTITY_OFFICES"
        [itemTypeId]="Constants.CONSTANT_PERMISSIONS.ENTITY_ADDRESSES"
        [enableDeleteAction]="!isViewMode()"
        [enableEditAction]="!isViewMode()"
        [enableAdd]="!isViewMode()"
        (addNewClicked)="addNew()"
        (actionClicked)="getAction($event)"
    />
</div>

<div class="my-2">
    <adaa-form-action-buttons
        [showSaveButton]="!isViewMode()"
        [saveButtonTitle]="'common.form.button.submit'"
        [cancelButtonTitle]="isViewMode() ? 'common.form.button.close' : 'common.form.button.cancel'"
        (saveClicked)="submit()"
        (cancelClicked)="close()"
    />
</div>

<adaa-addresses-editor #editor [pageMode]="addressesPageMode()" [currentEntityOffice]="entityOffice()" (editorClosed)="saveAddress($event)" />
